import { createAction } from 'redux-actions';
export var SET_PASSENGERS_CONFIG = 'SET_PASSENGERS_CONFIG';
export var setPassengersConfig = createAction(SET_PASSENGERS_CONFIG);
